<template>
    <transition name="fade">
        <div class="streamingVideo">

            <!-- Live Video -->
            <div class="vg-video-container">
                <iframe class="iframeVideo" width="1280" height="720" :src="streamURL()" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <div class="vg-cross" @click="leaveGallery()"/>
            
            <button class="meetingBtn" @click="openMeetingForm()">{{ $t('Jetzt einen Persönlichen Termin vereinbaren!') }}</button>
        </div>  
    </transition>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
    methods:{
        ...mapMutations(['handleGotoSituationTransition']),
        leaveGallery(){
            window.open("https://sales.flux-cms.de/Venjakob-Messe/", "_self");
            // this.handleGotoSituationTransition({situationID: 280866});
        },
        openMeetingForm(){
            var event = new CustomEvent("openMeetingRegister",{detail:{type: 'Register5'}});
            window.dispatchEvent(event);
        },
        streamURL(){
            var userLang = navigator.language || navigator.userLanguage; 
            if(userLang.includes("de"))
                return "https://www.youtube.com/embed/DkHHQ0Pxy9E"
            return "https://www.youtube.com/embed/1WiNOgwoFaM"
        }
    },
}
</script>

<style scoped>
    .streamingVideo{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: white;
    }
    .streaming-top-block-wrapper{
        position: absolute;
        display: flex;
        top: 20px;
        left: 20px;
    }
    .iframeVideo{
        height: 100%;
        margin-top: 40px;
        width: 100%;
        max-height: 80vh;
        cursor: pointer;
    }
    .vg-video-container{
        position: relative;
        display: inline-block;
        justify-content: center;
        align-items: center;
        width: 70%;
        height: 80%;
    }
    .vg-cross {
        position: absolute;
        left: 60px;
        top: 40px;
        cursor: pointer;
    }
    .vg-cross:after {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        top: 0;
        left: 10px;
        transform: rotate(45deg) ;
    }
    .vg-cross:before {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        top: 0;
        left: 10px;
        transform: rotate(-45deg);
    }
    .meetingBtn{
        position: absolute;
        bottom: 60px;
        right: 30px;

        padding: 10px;

        background-color:#1E717C ;
        color: white;
        border: none;

        cursor: pointer;
        width: 210px;
        font-size: 16px;
    }
</style>